<template>
	<button class="menu-btn" @click="menuStore.toggleOpen()">
		<Icon v-if="menuStore.isOpen" name="mdi:close" size="32" />
		<Icon v-else name="mdi:menu" size="32" />
	</button>
</template>

<script setup lang="ts">
	const menuStore = useMenuStore()
</script>

<style scoped lang="scss">
	.menu-btn {
		display: none;
		color: var(--white);

		@media (width <= 991.98px) {
			display: block;
		}
	}
</style>
